/** Cards within this index radius of the selection get a JPEG `src`. */
export const BIOSCOPE_FILMSTRIP_JPEG_RADIUS = 12;

export function shouldLoadFilmstripJpeg(
    index: number,
    selectedIndex: number,
    radius: number = BIOSCOPE_FILMSTRIP_JPEG_RADIUS
): boolean {
    return Math.abs(index - selectedIndex) <= radius;
}
